// goal.js — 영양 목표 계산 (마이페이지 · 회원가입 공용)

export const ACT_LV = [
  { v: '1', l: '비활동적', d: '거의 운동 안 함', factor: 1.2 },
  { v: '2', l: '가벼운 활동', d: '주 1~3회', factor: 1.375 },
  { v: '3', l: '보통 활동', d: '주 3~5회', factor: 1.55 },
  { v: '4', l: '활발한 활동', d: '주 6~7회', factor: 1.725 },
  { v: '5', l: '매우 활발', d: '하루 2회 이상', factor: 1.9 },
];

// 권장 칼로리 = 기초대사량(Mifflin-St Jeor) × 활동계수. gender: '0'·'M' 남 / '1'·'F' 여
export function recommendKcal({ height, weight, birthDate, gender, actLv }) {
  const h = Number(height); const w = Number(weight);
  if (!(h > 0) || !(w > 0) || !birthDate) return null;
  const birth = new Date(birthDate);
  if (Number.isNaN(birth.getTime())) return null;
  const now = new Date();
  let age = now.getFullYear() - birth.getFullYear();
  if (now < new Date(now.getFullYear(), birth.getMonth(), birth.getDate())) age -= 1;
  const male = gender === '0' || gender === 'M';
  const bmr = 10 * w + 6.25 * h - 5 * age + (male ? 5 : -161);
  const factor = ACT_LV.find((a) => a.v === String(actLv))?.factor ?? 1.375;
  return Math.round((bmr * factor) / 10) * 10;
}

// 비율(%) → g  (탄·단 4kcal/g, 지 9kcal/g)
export const rateToGrams = (kcal, carboRate, protRate, fatRate) => ({
  carbo: (Number(kcal) * Number(carboRate)) / 100 / 4,
  protein: (Number(kcal) * Number(protRate)) / 100 / 4,
  fat: (Number(kcal) * Number(fatRate)) / 100 / 9,
});

// 자주 쓰는 탄·단·지 비율
export const RATE_PRESETS = [
  { label: '균형 (50·25·25)', c: 50, p: 25, f: 25 },
  { label: '고단백 (40·35·25)', c: 40, p: 35, f: 25 },
  { label: '저탄수 (30·35·35)', c: 30, p: 35, f: 35 },
];
